import classNames from 'classnames/bind';
import styles from './FormButton.module.scss';
import { useFormContext } from 'react-hook-form';

let cx = classNames.bind(styles);

export function FormButton({ text = 'Submit', className, children, outlined, disabled, ...props }) {
	const classNameArray = className?.split(' ') || [];
	let formStateObj;
	if (useFormContext()) {
		const { formState } = useFormContext();
		formStateObj = formState;
	}
  // Dont render button on successful submit
  if (formStateObj?.isSubmitSuccessful) return;
	return (
		<button className={cx(['ns_form-button', 'form-button', 'button', outlined && 'is-style-outline', ...classNameArray])} disabled={disabled || formStateObj?.isSubmitting || (formStateObj?.submitCount > 0 && !formStateObj?.isValid)} {...props}>
			{!formStateObj?.isSubmitting && (children || text)}
			{formStateObj?.isSubmitting && (
				<div className={cx(['loading-spinner'])}>
					<svg viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x="7.83331" y="1" width="1.33333" height="4" rx="0.666667" fill="#000000" fillOpacity="0.4" />
						<rect x="7.65831" y="0.825" width="1.68333" height="4.35" rx="0.841667" stroke="#000000" strokeOpacity="0.4" strokeWidth="0.35" />
						<rect x="7.65831" y="12.825" width="1.68333" height="4.35" rx="0.841667" fill="#000000" stroke="#000000" strokeWidth="0.35" />
						<rect x="0.5" y="9.66663" width="1.33333" height="4" rx="0.666667" transform="rotate(-90 0.5 9.66663)" fill="#000000" fillOpacity="0.4" />
						<rect x="0.325" y="9.84163" width="1.68333" height="4.35" rx="0.841667" transform="rotate(-90 0.325 9.84163)" stroke="#000000" strokeOpacity="0.4" strokeWidth="0.35" />
						<rect x="12.5" y="9.66663" width="1.33333" height="4" rx="0.666667" transform="rotate(-90 12.5 9.66663)" fill="#000000" fillOpacity="0.4" />
						<rect x="12.325" y="9.84163" width="1.68333" height="4.35" rx="0.841667" transform="rotate(-90 12.325 9.84163)" stroke="#000000" strokeOpacity="0.4" strokeWidth="0.35" />
						<rect x="2.3717" y="3.81451" width="1.33333" height="4" rx="0.666667" transform="rotate(-45 2.3717 3.81451)" fill="#000000" fillOpacity="0.4" />
						<rect x="2.12422" y="3.81451" width="1.68333" height="4.35" rx="0.841667" transform="rotate(-45 2.12422 3.81451)" stroke="#000000" strokeOpacity="0.4" strokeWidth="0.35" />
						<rect x="10.857" y="12.2998" width="1.33333" height="4" rx="0.666667" transform="rotate(-45 10.857 12.2998)" fill="#000000" fillOpacity="0.4" />
						<rect x="10.6095" y="12.2998" width="1.68333" height="4.35" rx="0.841667" transform="rotate(-45 10.6095 12.2998)" stroke="#000000" strokeOpacity="0.4" strokeWidth="0.35" />
						<rect x="3.31451" y="15.1282" width="1.33333" height="4" rx="0.666667" transform="rotate(-135 3.31451 15.1282)" fill="#000000" fillOpacity="0.4" />
						<rect x="3.31451" y="15.3757" width="1.68333" height="4.35" rx="0.841667" transform="rotate(-135 3.31451 15.3757)" stroke="#000000" strokeOpacity="0.4" strokeWidth="0.35" />
						<rect x="11.7998" y="6.64294" width="1.33333" height="4" rx="0.666667" transform="rotate(-135 11.7998 6.64294)" fill="#000000" fillOpacity="0.4" />
						<rect x="11.7998" y="6.89043" width="1.68333" height="4.35" rx="0.841667" transform="rotate(-135 11.7998 6.89043)" stroke="#000000" strokeOpacity="0.4" strokeWidth="0.35" />
					</svg>
				</div>
			)}
		</button>
	);
}
